import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const cards = () => {

    const cards = document.querySelectorAll('.cards-block');

    if (!cards.length) return;

    cards.forEach(slider => {

        const prevEl = document.createElement('a');
        prevEl.href = '#';
        prevEl.className = 'swiper-button-prev';
        prevEl.setAttribute('aria-label', 'Previous slide');

        const nextEl = document.createElement('a');
        nextEl.href = '#';
        nextEl.className = 'swiper-button-next';
        nextEl.setAttribute('aria-label', 'Next slide');

        slider.appendChild(prevEl);
        slider.appendChild(nextEl);

        const swiper = new Swiper('.cards-block.swiper', {
            spaceBetween: 8,
            loop: false,
            observer: true,
            observeParents: true,
            slidesPerGroupSkip: 1,
            slidesPerView: 1.25,
            navigation: {
                nextEl,
                prevEl,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });

    });

}